// ============================================================
// CONFIGURAÇÃO DO SITE — SG Turismos
// Tudo o que você pode querer atualizar vive aqui, num lugar só.
// ============================================================

export const INSTAGRAM = {
  url: "https://www.instagram.com/sgturismos/",
  handle: "@sgturismos",
};

// WhatsApp: formato internacional, apenas números (55 + DDD + número)
export const WHATSAPP_NUMBER = "5541933005157";

export const WHATSAPP_DEFAULT_MESSAGE =
  "Olá! Vim pelo site da SG Turismos e quero saber mais sobre viajar de navio.";

export const whatsappLink = (message = WHATSAPP_DEFAULT_MESSAGE) =>
  `https://wa.me/${WHATSAPP_NUMBER}?text=${encodeURIComponent(message)}`;

// ROTEIROS & DESTINOS — exemplos editáveis; troque pelos roteiros reais quando quiser
export const ROTEIROS = [
  {
    name: "Costa Brasileira",
    route: "Santos → Ilhabela → Búzios",
    description: "Ilhas verdes, praias de água morna e pores do sol na costa sudeste.",
    image:
      "https://images.unsplash.com/photo-1769144256359-4599d84e9006?q=80&w=1200&auto=format&fit=crop",
  },
  {
    name: "Caribe Espanhol",
    route: "Miami → Cozumel → Grand Cayman",
    description: "Águas turquesa, ilhas caribenhas e dias inteiramente a bordo.",
    image:
      "https://images.pexels.com/photos/14712768/pexels-photo-14712768.jpeg?auto=compress&cs=tinysrgb&w=1200",
  },
  {
    name: "Mediterrâneo Clássico",
    route: "Roma → Barcelona → Marselha",
    description: "Portos históricos, cidades antigas e boa mesa em cada atracação.",
    image:
      "https://images.pexels.com/photos/18502397/pexels-photo-18502397.jpeg?auto=compress&cs=tinysrgb&w=1200",
  },
];

// ÁLBUM — troque "src" e "caption" pelas suas fotos reais quando quiser.
// "span" e "aspect" controlam o tamanho de cada foto no grid (pode deixar como está).
export const ALBUM_PHOTOS = [
  { src: "https://images.unsplash.com/photo-1780294181694-101764de9031?q=80&w=1600&auto=format&fit=crop", caption: "Alto-mar, sem pressa", span: "md:col-span-7", aspect: "aspect-[16/10]" },
  { src: "https://images.pexels.com/photos/34137983/pexels-photo-34137983.jpeg?auto=compress&cs=tinysrgb&w=1200", caption: "Convés sobre águas turquesa", span: "md:col-span-5", aspect: "aspect-[16/10]" },
  { src: "https://images.unsplash.com/photo-1590761397801-2ff9a6461c49?q=80&w=1200&auto=format&fit=crop", caption: "Espreguiçadeiras esperando o sol", span: "md:col-span-4", aspect: "aspect-[3/4]" },
  { src: "https://images.pexels.com/photos/32609062/pexels-photo-32609062.jpeg?auto=compress&cs=tinysrgb&w=1400", caption: "Pôr do sol em navegação", span: "md:col-span-8", aspect: "aspect-[16/9]" },
  { src: "https://images.unsplash.com/photo-1769144256359-4599d84e9006?q=80&w=1400&auto=format&fit=crop", caption: "Ancorado no porto", span: "md:col-span-6", aspect: "aspect-[16/10]" },
  { src: "https://images.unsplash.com/photo-1554254464-7046778097bf?q=80&w=1200&auto=format&fit=crop", caption: "Branco contra o céu", span: "md:col-span-6", aspect: "aspect-[4/3]" },
  { src: "https://images.pexels.com/photos/13048487/pexels-photo-13048487.jpeg?auto=compress&cs=tinysrgb&w=1200", caption: "Noite no deck superior", span: "md:col-span-5", aspect: "aspect-[3/4]" },
  { src: "https://images.unsplash.com/photo-1789111226473-40411d9b4f7b?q=80&w=1400&auto=format&fit=crop", caption: "Chegada à cidade antiga", span: "md:col-span-7", aspect: "aspect-[16/10]" },
  { src: "https://images.unsplash.com/photo-1508624217470-5ef0f947d8be?q=80&w=1200&auto=format&fit=crop", caption: "Espuma e mar de cima", span: "md:col-span-4", aspect: "aspect-[3/4]" },
  { src: "https://images.pexels.com/photos/36160654/pexels-photo-36160654.jpeg?auto=compress&cs=tinysrgb&w=1400", caption: "Porto entre falésias", span: "md:col-span-8", aspect: "aspect-[16/9]" },
];
